<template>
  <div class="about-container">
    <div class="about-container-left">
      <pageNav :active="1" />
    </div>
    <div class="about-container-right">
      <div class="about-container-right-team">
        <div class="about-container-right-team-row" v-for="i in 8" :key="i">
          <img src="https://img2.baidu.com/it/u=3906212634,2132778619&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500" alt="">
          <div class="about-container-right-team-row-title">张三<span>指导老师</span></div>
          <div class="about-container-right-team-row-desc">擅长为软硬件项目流程化、结构化提供解决方案，助力项目管理转型。擅长为软硬件项目流程化、结构化提供解决方案。</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AboutTeam',
  meta: {
    title: '关于'
  },
  data () {
    return {

    }
  }
}
</script>
